import React from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router";

import { Box, Typography, CircularProgress } from "@mui/material";
import { RightContainerStyled } from "../../assets/styles/theme";

import { usePostGenerateAuthorizationToken } from "../hooks";
import { localStorage } from "../helpers/localStorage";
import { useAuth } from "../context/AuthProvider";

interface RedirectComponentProps {
  onLoaderExit: () => void;
}

const RedirectComponent: React.FC<RedirectComponentProps> = ({
  onLoaderExit,
}) => {
  console.log("redirect Component");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSignInFlowStarted, setIsSignInFlowStarted] = React.useState(true);

  const {
    setAuthToken,
    setRefreshToken,
    setUserFirstName,
    setUserLastName,
    setUserId,
    setUserRoles,
    setUserEmail,
  } = localStorage;
  const { authToken } = useAuth();

  const {
    mutate: postGenerateAuthorizationToken,
    isPending,
    isSuccess,
  } = usePostGenerateAuthorizationToken();

  React.useEffect(() => {
    getUserDetails(searchParams.get("code"));
  }, []);

  const getUserDetails = (token: any) => {
    const reqBody: any = {
      token: token,
    };
    // call Post API
    postGenerateAuthorizationToken(reqBody, {
      onSuccess: GenerateAuthorizationTokenSuccess,
      onError: GenerateAuthorizationTokenError,
    });
  };

  const GenerateAuthorizationTokenSuccess = (response: any) => {
    console.log("GenerateAuthorizationTokenError Success", response);
    if (response?.message == "Successful" && response?.data) {
      setAuthToken(response?.data?.authorizationToken);
      setRefreshToken(response?.data?.refreshToken);
      setUserFirstName(response?.data?.firstName);
      setUserLastName(response?.data?.lastName);
      setUserEmail(response?.data?.emailAdrress)
      setUserId(response?.data?.userId);
      setUserRoles(
        response?.data?.appRoleAssignments?.map(
          (element: { roleName: any }) => element?.roleName
        )
      );
      authToken();

      let roles = response?.data?.appRoleAssignments?.map(
        (element: { roleName: any }) => element?.roleName
      );
      console.log("roles controller", roles);
      if (roles.includes("Admin") || roles.includes("Administrator")) {
        setIsSignInFlowStarted(false);
        onLoaderExit();
        navigate("/clients");
      } else {
        setIsSignInFlowStarted(false);
        onLoaderExit();
        navigate("/file-list");
      }
    } else {
      setIsSignInFlowStarted(false);
      onLoaderExit();
      navigate("/error-page", {state : "Something went wrong. Please Try again later"});
    }
  };

  const GenerateAuthorizationTokenError = (error: any) => {
    console.log("GenerateAuthorizationTokenError Error", error);
    setIsSignInFlowStarted(false);
    onLoaderExit();
    navigate("/error-page", {state : error?.data?.message || error?.data?.error});
  };

  console.log("isSignInFlowStarted", isSignInFlowStarted);

  return (
    <RightContainerStyled>
      {isSignInFlowStarted && isPending && (
        <Box className="centerAlignLoader">
          <CircularProgress size="2.5rem" />
        </Box>
      )}
    </RightContainerStyled>
  );
};

export default RedirectComponent;
